module.exports = __webpack_public_path__ + "static/media/miku-bg.0ebca9e6.mp4";